import _sortBy from 'lodash/sortBy';

export const sortOptionsWithDefaultFirst = (
    options: DropdownInputOption[],
    defaultId: Maybe<string>,
): DropdownInputOption[] => {
    const indexOfDefault = options.findIndex(
        (option: DropdownInputOption): boolean => option.id === defaultId,
    );

    let sorted = options;
    let defaultOption = null;

    if (indexOfDefault > -1) {
        const removed = options.splice(indexOfDefault, 1);

        if (removed.length > 0) {
            [defaultOption] = removed;
        }
    }

    sorted = _sortBy(options, 'label');

    if (defaultOption !== null) {
        return [defaultOption, ...sorted];
    }

    return sorted;
};
